<template>
    <main class="main" id="main">

        <!---------------Blog-------------------->

        <div class="top_line">
            <div class="container">
                <h1>Блог</h1>
            </div>
        </div>

        <section class="section s-blog">
            <div class="container">
                <div class="blog">

                    <div class="blog_header">
                        <div class="blog_nav">
                            <div v-for="(tag, key) in tags" :key="tag" :class="activeTag === key ? 'nav_link active': 'nav_link'" @click="activeTag = key">
                                {{tag}}
                            </div>

                        </div>
                    </div>

                    <div class="blog_body">

                        <div class="blog_page">

                            <div v-for="(blog, index) in blogs" :key="index" :class="index%2 ? 'post bg_color' : 'post'" v-if="blog.show">

                                <div class="post_description">
                                    <img :src="blog.image" v-if="blog.image !== 'https://img.when-hungry.com/'" alt="">
                                    <div class="post_title">
                                        <h3>{{blog.title}}</h3>
                                        <span>{{blog.created_at}}</span>
                                    </div>
                                    <div class="post_sm">
                                        <span class="post_time_sm">{{blog.created_at}}</span>
                                        <router-link tag="button" :to="'/blog/' + blog.id" type="button" class="menu_item_btn">Читать всё</router-link>
                                    </div>
                                </div>
                                <div class="post_text">
                                    <h3>{{blog.title}}</h3>
                                    <p v-html="blog.short_text"></p>
                                </div>
                            </div>
                        </div>

                        <div class="blog_right">
                            <div class="blog_extra_info">
                                <div id="vk_groups"></div>
                                <div class="links">
                                    <ul>
                                        <li><router-link to="/present">В магазин</router-link></li>
                                        <li><router-link to="/affiliate">Заработать на еду</router-link></li>
                                        <li><router-link to="/contacts">Прислать свой рецепт или статью</router-link></li>
                                        <li><router-link to="/investment">Партнерская программа</router-link></li>
                                    </ul>
                                </div>

                            </div>
                            <div class="links">
                                <ul>
                                  <li><router-link to="/present">В магазин</router-link></li>
                                  <li><router-link to="/affiliate">Заработать на еду</router-link></li>
                                  <li><router-link to="/contacts">Прислать свой рецепт или статью</router-link></li>
                                  <li><router-link to="/investment">Партнерская программа</router-link></li>
                                </ul>
                            </div>
                        </div>
                        <div class="links">
                            <ul>
                              <li><router-link to="/present">В магазин</router-link></li>
                              <li><router-link to="/affiliate">Заработать на еду</router-link></li>
                              <li><router-link to="/contacts">Прислать свой рецепт или статью</router-link></li>
                              <li><router-link to="/investment">Партнерская программа</router-link></li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>

        </section>
    </main>
</template>

<script>
import $ from 'jquery'
import axios from '@/router/http'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel'
export default {
  name: 'blog',
  props: ['city', 'mapinit', 'geo', 'auth'],
  data () {
    return {
      itemLimit: 10,
      tags: {
        all: 'показать все',
        news: 'новости',
        interesting: 'интересное',
        hyip: 'хайп',
        interview: 'интервью',
        media: 'мы в сми',
        collections: 'подборки',
        food: 'мировая еда',
        culinary_blog: 'кулинарный блог',
        memes: 'мемы'
      },
      activeTag: 'news',
      blogs: []
    }
  },
  created () {
    if (this.auth.uid) this.initAjax()
    else {
      let interval = setInterval(() => {
        if (this.auth.uid) {
          clearInterval(interval)
          this.initAjax()
        }
      }, 100)
    }
  },
  mounted () {
    /*
    this.checkPosition()
    $(document).scroll(() => {
      this.checkPosition()
    })
    $(window).resize(() => {
      this.checkPosition()
    })
    */
    $('.blog_nav').slick({
      infinite: false,
      dots: false,
      arrows: true,
      slidesToShow: 7,
      slidesToScroll: 1,
      swipeToSlide: true,
      waitForAnimate: true,
      speed: 200,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 6,
            variableWidth: true
          }
        },
        {
          breakpoint: 986,
          settings: {
            slidesToShow: 5,
            variableWidth: true,
            arrows: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 5,
            variableWidth: true,
            dots: true,
            arrows: false
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 3,
            variableWidth: true,
            dots: true,
            arrows: false
          }
        }
      ]
    })
    if (typeof VK === 'object') {
      console.log(VK)
      VK.Widgets.Group('vk_groups', {
        mode: 3,
        width: 'auto'
      }, 153817553)
    }
  },
  watch: {
    activeTag (val) {
      this.reshow()
      this.itemLimit = 10
    }
  },
  methods: {
    initAjax () {
      axios.get('https://lk.when-hungry.com/mobile/get-blog?uid=' + this.auth.uid).then(response => {
        this.blogs = response.data
        this.reshow()
      })
    },
    checkPosition () {
      let element
      if ($('.post').length !== 0) element = $('.post:visible').eq(-3)
      // console.log(element)
      if (element !== undefined && element.length !== 0) {
        var divPosition = element.offset()
        var divTop = divPosition.top
        var divLeft = divPosition.left
        var divWidth = element.width()
        // var divHeight = element.height()
        var topScroll = $(document).scrollTop()
        var leftScroll = $(document).scrollLeft()
        // var screenWidth = $(window).width()
        var screenHeight = $(window).height()
        var seeX1 = leftScroll
        // var seeX2 = screenWidth + leftScroll
        var seeY1 = topScroll
        var seeY2 = screenHeight + topScroll
        var divX1 = divLeft
        // var divX2 = divLeft + divHeight
        var divY1 = divTop
        var divY2 = divTop + divWidth
        // if (divX1 >= seeX1 && divX2 <= seeX2 && divY1 >= seeY1 && divY2 <= seeY2) {
        /*
        console.table({
          divX1: divX1,
          seeX1: seeX1,
          divY1: divY1,
          seeY1: seeY1,
          divY2: divY2,
          seeY2: seeY2
        })
        */
        if (divX1 >= seeX1 && divY1 >= seeY1 && (divY2 - 100) <= seeY2) {
          this.itemLimit += 5
          this.reshow()
          // element.style({background: 'green'})
        } // else element.style({background: 'red'})
      }
    },
    reshow () {
      // let count = 0
      for (let blogId in this.blogs) {
        let blog = this.blogs[blogId]
        if ((this.activeTag === 'all' || this.activeTag === blog.tags || (blog.tags && ((blog.tags).split(',')).indexOf(this.activeTag) !== -1))) { // count <= this.itemLimit &&
          this.blogs[blogId].show = 1
          // count++
        } else this.blogs[blogId].show = 0
      }
      // activeTag === 'all' || activeTag === blog.tags || blog.tags && ((blog.tags).split(',')).indexOf(activeTag) !== -1
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/blog.vue